import React, { Component } from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'

export default class Region extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage()
    }
  }
  render () {
    const { language } = this.state
    if (this.props.regionList != null) {
      return this.props.regionList.map(item => {
        if (this.props.selectedvalue === item.Abbreviation) {
          if (item.Id === 51) {
            return [
              <option value='' translate key='usterrcomm'>{t[language].usterrcomm}</option>,
              <option value={item.Abbreviation} selected={this.props.selectedvalue === item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
            ]
          } else {
            return <option value={item.Abbreviation} selected={this.props.selectedvalue === item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
          }
        } else {
          if (item.Id === 51) {
            return [
              <option value='' translate key='usterrcomm'>{t[language].usterrcomm}</option>,
              <option value={item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
            ]
          } else {
            return <option value={item.Abbreviation} >{item.Abbreviation + ' - ' + item.Name}</option>
          }
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Region.js